import '../css/app.css';

import 'lazysizes';

import loadComponents from 'gia/loadComponents';
import components from './components';

window.loadComponents = loadComponents;
window.components = components;
loadComponents(components);


import { createApp, h } from 'vue';
import Checkout from './vue-components/Checkout.vue';
import ConnectEmbed from './vue-components/ConnectEmbed.vue';
import ConnectOnboarding from './vue-components/ConnectOnboarding.vue';
// import ClassesSimple from './vue-components/ClassesSimple.vue';
import TeacherClasses from './vue-components/TeacherClasses.vue';
import TeacherProfile from './vue-components/TeacherProfile.vue';
import StudentProfile from './vue-components/StudentProfile.vue';
import Classes from './vue-components/Classes.vue';
import StudentBookings from './vue-components/StudentBookings.vue';
import Session from './vue-components/Session.vue';
import BookingsConfirmationSearch from './vue-components/BookingsConfirmationSearch.vue';
import TeacherPackages from './vue-components/TeacherPackages.vue';
import ClassesHome from './vue-components/ClassesHome.vue';
import TeacherCheckout from './vue-components/TeacherCheckout.vue';
import ConnectTeacher from './vue-components/ConnectTeacher.vue';
import TeacherManagePlan from './vue-components/TeacherManagePlan.vue';
import TeacherSession from './vue-components/TeacherSession.vue';
import TeacherAccount from './vue-components/TeacherAccount.vue';
import TeacherConnectLink from './vue-components/TeacherConnectLink.vue';
import SidebarClasses from './vue-components/SidebarClasses.vue';
import UnsubWeeklyEmails from './vue-components/UnsubWeeklyEmails.vue';
import BookingChart from './vue-components/BookingChart.vue';

function initVue() {
  if (document.querySelector('#app-connect-onboarding')) {
    const app = createApp({
      components: {
        ConnectOnboarding
      }
    });
    app.mount('#app-connect-onboarding');
  }
  if (document.querySelector('#app-checkout')) {
    const app = createApp({
      components: {
        Checkout
      }
    });
    app.mount('#app-checkout');
  }
  if (document.querySelector('.app-connect-embed')) {
    document.querySelectorAll('.app-connect-embed').forEach(el => {
      const app = createApp({
        components: {
          ConnectEmbed
        }
      });
      app.mount(el);
    });
  }
  if (document.querySelector('#app-connect-teacher')) {
    const app = createApp({
      components: {
        ConnectTeacher
      }
    });
    app.mount('#app-connect-teacher');
  }
  // if (document.querySelector('#app-classes-simple')) {
  //   const app = createApp({
  //     components: {
  //       ClassesSimple
  //     }
  //   });
  //   app.mount('#app-classes-simple');
  // }
  if (document.querySelector('#app-teacher-classes')) {
    const app = createApp({
      components: {
        TeacherClasses
      }
    });
    app.mount('#app-teacher-classes');
  }
  if (document.querySelector('#app-teacher-profile')) {
    const app = createApp({
      components: {
        TeacherProfile
      }
    });
    app.mount('#app-teacher-profile');
  }
  if (document.querySelector('#app-teacher-account')) {
    const app = createApp({
      components: {
        TeacherAccount
      }
    });
    app.mount('#app-teacher-account');
  }
  if (document.querySelector('#app-student-profile')) {
    const app = createApp({
      components: {
        StudentProfile
      }
    });
    app.mount('#app-student-profile');
  }
  if (document.querySelector('#app-student-bookings')) {
    const app = createApp({
      components: {
        StudentBookings
      }
    });
    app.mount('#app-student-bookings');
  }
  if (document.querySelector('#app-session')) {
    const app = createApp({
      components: {
        Session
      }
    });
    app.mount('#app-session');
  }
  if (document.querySelector('#app-classes')) {
    console.log('Found #app-classes element, attempting to mount Vue app');
    const app = createApp({
      components: {
        Classes
      }
    });
    app.mount('#app-classes');
    console.log('Vue app mounted');
  }
  if (document.querySelector('#app-classes-home')) {
    console.log('Found #app-classes-home element, attempting to mount Vue app');
    const app = createApp({
      components: {
        ClassesHome
      }
    });
    app.mount('#app-classes-home');
    console.log('Vue app mounted');
  }
  if (document.querySelector('#app-bookings-confirmation-search')) {
    const app = createApp({
      components: {
        BookingsConfirmationSearch
      }
    });
    app.mount('#app-bookings-confirmation-search');
  }
  if (document.querySelector('#app-teacher-packages')) {
    const app = createApp({
      components: {
        TeacherPackages
      }
    });
    app.mount('#app-teacher-packages');
  }
  if (document.querySelector('#app-teacher-session')) {
    const app = createApp({
      components: {
        TeacherSession
      }
    });
    app.mount('#app-teacher-session');
  }
  if (document.querySelector('#app-sidebar-classes')) {
    const app = createApp({
      components: {
        SidebarClasses
      }
    });
    app.mount('#app-sidebar-classes');
  }

  if (document.querySelector('#app-unsub-weekly-emails')) {
    const app = createApp({
      components: {
        UnsubWeeklyEmails
      }
    });
    app.mount('#app-unsub-weekly-emails');
  }

  if (document.querySelector('#app-booking-chart')) {
    const app = createApp({
      components: {
        BookingChart
      }
    });
    app.mount('#app-booking-chart');
  }

  if (document.querySelector('.app-teacher-checkout')) {
    console.log('Found .app-teacher-checkout element, attempting to mount Vue app');
    document.querySelectorAll('.app-teacher-checkout').forEach(el => {
      const app = createApp({
        components: {
          TeacherCheckout
        }
      });
      app.mount(el);
    });
  }

  if (document.querySelector('.app-teacher-manage-plan')) {
    document.querySelectorAll('.app-teacher-manage-plan').forEach(el => {
      const app = createApp({
        components: {
          TeacherManagePlan
        }
      });
      app.mount(el);
    });
  }

  if (document.querySelector('.app-teacher-connect-link')) {
    document.querySelectorAll('.app-teacher-connect-link').forEach(el => {
      const app = createApp({
        components: {
          TeacherConnectLink
        }
      });
      app.mount(el);
    });
  }
}

initVue();
